import { BaseService } from "./../../base";
export class DraftCopyService extends BaseService {
  static get entity() {
    return "draft_copy";
  }
  static get name() {
    return "draft_copy";
  }

  static async getDraftCopyFindByPatientUser(user_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_patient_and_user/${user_id}`, this.name);
  }
}
